<div id="marketplace-feedback-modal" class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>

  <button (click)="modal.dismiss()" class="close" aria-describedby="modal-title" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="mb-4">
    <p>
      <fa-icon class="me-2" icon="info-circle"></fa-icon>
      <span [innerHTML]="rulesText"></span>
    </p>
  </div>

  <formly-form [fields]="fields" [form]="form" [(model)]="model"></formly-form>
</div>

<div class="modal-footer">
  <button
    [class.loading]="loadingService.loading$ | async"
    (click)="modal.dismiss()"
    class="btn btn-outline-secondary"
    type="button"
  >
    {{ "Cancel" | translate }}
  </button>

  <button
    [class.loading]="loadingService.loading$ | async"
    (click)="saveFeedback()"
    class="btn btn-primary"
    type="button"
  >
    {{ "Save feedback" | translate }}
  </button>
</div>

<ng-template #feedbackOptionTemplate let-item="item">
  <div class="d-flex align-items-center">
    <fa-icon [icon]="item.icon" class="me-2"></fa-icon>
    <span>{{ item.label }}</span>
  </div>
</ng-template>
